import { styled } from '@mui/material';
import { NavLink } from 'react-router';
import getColor, { Color } from 'utils/getColor';

export const NavLinkStyled = styled(NavLink, {
  shouldForwardProp: (prop: string) =>
    !['$color', '$isNotificationLink'].includes(prop)
})<{
  $color?: Color;
  $isNotificationLink?: boolean;
}>`
  text-decoration: none;
  ${({ $color }) => $color && `color: ${getColor($color)};`}
  ${({ $isNotificationLink }) => $isNotificationLink && `&&& { padding: 0; }`}

  &::after {
    content: '';
    transition: width 0.2s;
    ${({ $color }) => $color && `background: ${getColor($color)};`}
    display: block;
    height: 2px;
    width: 0;
    padding-top: 2px;
    margin-top: 12.5px;
  }
  &.active::after {
    width: 100%;
  }
`;
